import { List } from "immutable";

import { nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import nativeCommsMessageTypes from "../../nativeComms/nativeCommsMessageTypes";
import toMenuItemRecord from "./toMenuItemRecord";

export default (state, disabledItems) => {
  return List([
    {
      label: "Tutorial",
      messageType: nativeCommsMessageTypes.SHOW_TUTORIAL,
      shortcut: null,
      disabled: false,
      hasSeparator: false
    },
    {
      label: "Help",
      messageType: nativeCommsBroadcastMessageTypes.SHOW_HELP,
      shortcut: null,
      disabled: false,
      hasSeparator: true
    },
    {
      label: "About Aeon Timeline...",
      messageType: nativeCommsMessageTypes.SHOW_ABOUT,
      shortcut: null,
      disabled: false,
      hasSeparator: false
    }
  ]).map(item => toMenuItemRecord(item, disabledItems));
};
